const DEFAULT_MULTIPLIER = 1;

function readMultiplier() {
  const queryValue = Number(new URLSearchParams(window.location.search).get('clock'));
  if (Number.isFinite(queryValue) && queryValue > 0) return Math.min(3600, queryValue);
  const storedValue = Number(window.localStorage.getItem('melodia.total-defence.clock'));
  if (Number.isFinite(storedValue) && storedValue > 0) return Math.min(3600, storedValue);
  return DEFAULT_MULTIPLIER;
}

export class WorldClock {
  constructor({ realOrigin = Date.now(), virtualOrigin = realOrigin, multiplier = readMultiplier() } = {}) {
    this.realOrigin = realOrigin;
    this.virtualOrigin = virtualOrigin;
    this.multiplier = multiplier;
  }

  now(realNow = Date.now()) {
    return this.virtualOrigin + ((realNow - this.realOrigin) * this.multiplier);
  }

  realAt(virtualNow) {
    return this.realOrigin + ((virtualNow - this.virtualOrigin) / this.multiplier);
  }

  elapsed(start, realNow = Date.now()) {
    return Math.max(0, this.now(realNow) - start);
  }

  isAccelerated() {
    return this.multiplier !== 1;
  }

  dayPhase(realNow = Date.now()) {
    const hours = new Date(realNow).getHours() + (new Date(realNow).getMinutes() / 60);
    const daylight = Math.max(0, Math.sin(((hours - 6) / 24) * Math.PI * 2));
    return { hours, daylight, night: daylight < 0.2 };
  }

  label(realNow = Date.now()) {
    return new Date(realNow).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }
}

export function formatDuration(milliseconds) {
  const totalMinutes = Math.max(0, Math.ceil(milliseconds / 60000));
  if (totalMinutes < 60) return `${totalMinutes} min`;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return minutes ? `${hours}h ${minutes}m` : `${hours}h`;
}
